import {useState, useEffect, Fragment} from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import axios from 'axios';
import { Accordion, Col, Form, Row, Tab, Tabs } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { BarChart } from '@mui/x-charts';
import useBreakpoint from './useBreakpoint';
import "./components/CustomTableRow.scss";

export default function AllEvaluationsSingleView() {
    const [size] = useBreakpoint();

    const { id } = useParams();
  const [data, setData] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    axios.get("http://ascola-dev01.it.auth.gr/api/mass-evaluations/" + id, {
        headers: { Authorization: "Bearer " + localStorage.getItem('access_token')} })
    .then((response) => {
        console.log(response); setData(response.data);
    });
}, []);

  return (
    <><div className="title mb-4">
            <h1 className="register-text" style={{fontSize: 40, marginBottom: 25, marginTop: 100}}>Course evaluations</h1></div>
    <Row style={{ marginLeft: 0, marginRight: 0}}>
        <Col style={{marginTop: 75, marginBottom: 80}}>
        {(size !== "xs" && size !== "sm" && size !== "md") ? (
            <Table responsive style={{background: "#ffff", color: "black", width: "80%"}} className="rounded-3 mx-auto">
                <thead className='thead-font'>
                    <tr>
                    <th style={{paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>COURSE TITLE</th>
                    <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>COURSE CODE</th>
                    <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>ACADEMIC TERM</th>
                    <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>ECTS</th>
                    <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>INSTITUTION</th>
                    </tr>
                </thead>
                <tbody className='tbody-font'>
                    <tr>
                    <td style={{paddingTop: 0, paddingBottom: 20, paddingLeft: 24}} className='border-hidden body'>{data?.Course?.course_title}</td>
                    <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden  body'>{data?.Course?.course_code}</td>
                    <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden  body'>{data?.Course?.academic_term}</td>
                    <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden  body'>{data?.Course?.ects}</td>
                    <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden  body'>{data?.Course?.institution_schac}</td>
                    </tr>
                </tbody>
                </Table>)
                : (<div
                    className={`rounded mb-2 ${
                      ""
                    } table-row`}
                  >
                    <div
                      className={`p-3 justify-content-around align-items-center custom-row 
                       `}
                       style={{width: "100%"}}
                    //   onClick={onClickHandler}
                    //   onMouseDown={onMouseDown}
                    >
                <Fragment key={"row-col-"}>
              
                    <div className="row">
                      <div className="col table-header">
                        {"COURSE TITLE:"}
                      </div>
                      <div className="col body">
                        
                      {data?.Course?.course_title}
                      </div>
                    </div>
                  
                </Fragment>
                <Fragment key={"row-col-"}>
              
                    <div className="row">
                      <div className="col table-header">
                        {"COURSE CODE:"}
                      </div>
                      <div className="col body">
                        
                      {data?.Course?.course_code}
                      </div>
                    </div>
                  
                </Fragment>
                <Fragment key={"row-col-"}>
              
                    <div className="row">
                      <div className="col table-header">
                        {"ACADEMIC TERM:"}
                      </div>
                      <div className="col body">
                        
                      {data?.Course?.academic_term}
                      </div>
                    </div>
                  
                </Fragment>
                <Fragment key={"row-col-"}>
              
                    <div className="row">
                      <div className="col table-header">
                        {"ECTS:"}
                      </div>
                      <div className="col body">
                        
                      {data?.Course?.ects}
                      </div>
                    </div>
                  
                </Fragment>
                <Fragment key={"row-col-"}>
              
                    <div className="row">
                      <div className="col table-header">
                        {"INSTITUTION:"}
                      </div>
                      <div className="col body">
                        
                      {data?.Course?.institution_schac}
                      </div>
                    </div>
                  
                </Fragment>
                
                </div></div>) }
        </Col>
    </Row>
    <Row style={{ marginLeft: 0, marginRight: 0}}><Col style={{marginBottom: 80}}>
    <Accordion className='border-hidden label-style mx-auto' style={(size !== "xs" && size !== "sm" && size !== "md") ? {color: "black", width: "80%"} : {color: "black", width: "95%"}} id={"accordion-iias-active"}>
                        <Accordion.Item eventKey="0" className='label-style'>
                            <Accordion.Header className='document-item label-style'>Background info</Accordion.Header>
                            <Accordion.Body className='border-hidden label-style' >
                                <div style={{paddingLeft: 12, paddingTop: 15, paddingBottom: 20}}>
                                {/* <div className='h6-style'>What best describes your gender? </div> */}
                                <Row style={{marginTop: 12}}>
                                    <Col xs={12} sm={12} md={12} lg={6} className='flex-center'>
                                    <div><div className='question-title'>What best describes your gender?</div>
                                    <div className='flex-center'><PieChart
                                        series={[
                                            {arcLabel: (item) => `${parseFloat((100 * item.value / data?.Count).toFixed(2))}%`,
                                            arcLabelMinAngle: 35,
                                            arcLabelRadius: '60%',
                                            data: [
                                                { id: 0, value: data?.EvaluationSubmissions?.gender_groups?.Female, label: 'Female' },
                                                { id: 1, value: data?.EvaluationSubmissions?.gender_groups?.Male, label: 'Male' },
                                                { id: 2, value: data?.EvaluationSubmissions?.gender_groups["Non-binary"], label: 'Non-binary' },
                                                { id: 3, value: data?.EvaluationSubmissions?.gender_groups["Other"], label: 'Other' },
                                                { id: 4, value: data?.EvaluationSubmissions?.gender_groups["Prefer not to say"], label: 'Prefer not to say' },
                                                { id: 5, value: data?.EvaluationSubmissions?.gender_groups["Unsure how to describe myself"], label: 'Unsure how to describe myself' },
                                            ],
                                            },
                                        ]}
                                        sx={{
                                            [`& .${pieArcLabelClasses.root}`]: {
                                              fontWeight: 'bold',
                                            },
                                          }}
                                        width={400}
                                        height={400}
                                        margin={{ top: 50, bottom: 100, left: 100, right:100 }}
                                        slotProps={{
                                            legend: {
                                            //   labelStyle: {
                                            //     tableLayout: 'fixed',
                                            //   },
                                              direction: 'row',
                                              position: {
                                                horizontal: 'middle',
                                                vertical: 'bottom',
                                              },padding: 0,
                                            },
                                          }}
                                    /></div><div className='total-count-label' style={{marginTop: 10}}>Total: {data?.Count} evaluations</div></div>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={6} className='flex-center'>
                                    <div><div className='question-title'>What is your age?</div>
                                    <div className='flex-center'><PieChart
                                        series={[
                                            {arcLabel: (item) => `${parseFloat((100 * item.value / data?.Count).toFixed(2))}%`,
                                            arcLabelMinAngle: 35,
                                            arcLabelRadius: '60%',
                                            data: [
                                                { id: 0, value: data?.EvaluationSubmissions?.age_groups["16-18"], label: '16-18' },
                                                { id: 1, value: data?.EvaluationSubmissions?.age_groups["19-25"], label: '19-25' },
                                                { id: 2, value: data?.EvaluationSubmissions?.age_groups["26-30"], label: '26-30' },
                                                { id: 3, value: data?.EvaluationSubmissions?.age_groups["31-60"], label: '31-60' },
                                                { id: 4, value: data?.EvaluationSubmissions?.age_groups["61+"], label: '61+' },
                                            ],
                                            },
                                        ]}
                                        sx={{
                                            [`& .${pieArcLabelClasses.root}`]: {
                                              fontWeight: 'bold',
                                            },
                                          }}
                                        width={400}
                                        height={400}
                                        margin={{ top: 50, bottom: 100, left: 100, right:100 }}
                                        slotProps={{
                                            legend: {
                                            //   labelStyle: {
                                            //     tableLayout: 'fixed',
                                            //   },
                                              direction: 'row',
                                              position: {
                                                horizontal: 'middle',
                                                vertical: 'bottom',
                                              },padding: 0,
                                            },
                                          }}
                                    /></div><div className='total-count-label' style={{marginTop: 10}}>Total: {data?.Count} evaluations</div></div>
                                    </Col>
                                </Row>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion></Col></Row>
                    <Row style={{ marginLeft: 0, marginRight: 0}}><Col style={{marginBottom: 80}}>
                        <Accordion className='border-hidden label-style mx-auto' style={(size !== "xs" && size !== "sm" && size !== "md") ? {color: "black", width: "80%"} : {color: "black", width: "95%"}} id={"accordion-iias-active"}>
                        <Accordion.Item eventKey="0" className='label-style'>
                            <Accordion.Header className='document-item label-style'>General impression</Accordion.Header>
                            <Accordion.Body className='border-hidden label-style' >
                                <div style={{paddingLeft: 12, paddingTop: 15, paddingBottom: 20}}>
                                {/* <div className='h6-style'>What best describes your gender? </div> */}
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The overall quality of the course was sufficient</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.course_quality["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_quality["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_quality["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_quality["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_quality["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                    />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The course was well organized</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.course_organisation["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_organisation["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_organisation["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_organisation["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_organisation["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The course subject matter was adapted to my prior knowledge</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.course_prerequisites["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_prerequisites["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_prerequisites["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_prerequisites["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_prerequisites["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The course objectives were clear to me</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.course_clear_objectives["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_clear_objectives["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_clear_objectives["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_clear_objectives["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_clear_objectives["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The relevance of the topics of this course within the context of my field of study was clear to me</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.course_topic_relevance["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_topic_relevance["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_topic_relevance["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_topic_relevance["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_topic_relevance["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The learning management system was clearly structured</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.course_online_tools["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_online_tools["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_online_tools["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_online_tools["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_online_tools["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion></Col></Row>
                    <Row style={{ marginLeft: 0, marginRight: 0}}><Col style={{marginBottom: 80}}>
                        <Accordion className='border-hidden label-style mx-auto' style={(size !== "xs" && size !== "sm" && size !== "md") ? {color: "black", width: "80%"} : {color: "black", width: "95%"}} id={"accordion-iias-active"}>
                        <Accordion.Item eventKey="0" className='label-style'>
                            <Accordion.Header className='document-item label-style'>Learning methods</Accordion.Header>
                            <Accordion.Body className='border-hidden label-style' >
                                <div style={{paddingLeft: 12, paddingTop: 15, paddingBottom: 20}}>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The lectures of the course were adding to my understanding of the topic(s)</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.course_relevant_lectures["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_relevant_lectures["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_relevant_lectures["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_relevant_lectures["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_relevant_lectures["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The activities in the course motivated me</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.course_motivational_activities["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_motivational_activities["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_motivational_activities["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_motivational_activities["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_motivational_activities["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The activities in the course prepared me for my future employment</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.course_future_employment["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_future_employment["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_future_employment["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_future_employment["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_future_employment["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The activities in the course helped me reflect on current societal challenges</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.course_societal_reflexion["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_societal_reflexion["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_societal_reflexion["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_societal_reflexion["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_societal_reflexion["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The relevance of the topics of this course within the context of my field of study was clear to me</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.course_topic_relevance["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_topic_relevance["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_topic_relevance["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_topic_relevance["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_topic_relevance["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>I understand how I can apply the course materials in a practical setting</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.course_materials["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_materials["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_materials["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_materials["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_materials["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The number of social interactions with students in the course was sufficient</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.course_social_interaction["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_social_interaction["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_social_interaction["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_social_interaction["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_social_interaction["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The study load was evenly distributed throughout the course</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.course_study_load["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_study_load["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_study_load["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_study_load["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.course_study_load["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion></Col></Row>
                    <Row style={{ marginLeft: 0, marginRight: 0}}><Col style={{marginBottom: 80}}>
                        <Accordion className='border-hidden label-style mx-auto' style={(size !== "xs" && size !== "sm" && size !== "md") ? {color: "black", width: "80%"} : {color: "black", width: "95%"}} id={"accordion-iias-active"}>
                        <Accordion.Item eventKey="0" className='label-style'>
                            <Accordion.Header className='document-item label-style'>Teachers</Accordion.Header>
                            <Accordion.Body className='border-hidden label-style' >
                                <div style={{paddingLeft: 12, paddingTop: 15, paddingBottom: 20}}>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The teacher(s) of the course was/were approachable</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.teacher_approachability["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_approachability["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_approachability["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_approachability["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_approachability["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>There were enough contact moments with the teacher(s) (office hours, lectures)</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.teacher_contact_moments["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_contact_moments["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_contact_moments["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_contact_moments["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_contact_moments["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The teacher(s) provided opportunities to discuss difficulties / questions</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.teacher_discussion_opportunities["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_discussion_opportunities["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_discussion_opportunities["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_discussion_opportunities["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_discussion_opportunities["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The teacher(s) was able to deal with specific needs I had as an exchange student</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.teacher_specific_needs["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_specific_needs["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_specific_needs["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_specific_needs["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_specific_needs["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The teacher(s) taught in a motivating manner</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.teacher_motivating_manner["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_motivating_manner["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_motivating_manner["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_motivating_manner["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_motivating_manner["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The teacher(s) showed interest in international perspectives</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.teacher_international_perspective["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_international_perspective["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_international_perspective["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_international_perspective["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.teacher_international_perspective["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion></Col></Row>
                    <Row style={{ marginLeft: 0, marginRight: 0}}><Col style={{marginBottom: 80}}>
                        <Accordion className='border-hidden label-style mx-auto' style={(size !== "xs" && size !== "sm" && size !== "md") ? {color: "black", width: "80%"} : {color: "black", width: "95%"}} id={"accordion-iias-active"}>
                        <Accordion.Item eventKey="0" className='label-style'>
                            <Accordion.Header className='document-item label-style'>Cultural differences</Accordion.Header>
                            <Accordion.Body className='border-hidden label-style' >
                                <div style={{paddingLeft: 12, paddingTop: 15, paddingBottom: 20}}>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>Input from an international perspective was valued in the course</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.cultural_international_perspective["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_international_perspective["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_international_perspective["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_international_perspective["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_international_perspective["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The course provided me with opportunities to share my thoughts and feelings</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.cultural_thought_sharing["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_thought_sharing["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_thought_sharing["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_thought_sharing["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_thought_sharing["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The learning activities allowed for contact with other local/exchange students</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.cultural_student_contact["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_student_contact["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_student_contact["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_student_contact["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_student_contact["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>I experienced no cultural obstacles in the course</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.cultural_prejudice["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_prejudice["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_prejudice["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_prejudice["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_prejudice["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>I experienced no language obstacles/barriers in the course</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.cultural_language_barriers["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_language_barriers["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_language_barriers["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_language_barriers["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.cultural_language_barriers["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion></Col></Row>
                    <Row style={{ marginLeft: 0, marginRight: 0}}><Col style={{marginBottom: 80}}>
                        <Accordion className='border-hidden label-style mx-auto' style={(size !== "xs" && size !== "sm" && size !== "md") ? {color: "black", width: "80%"} : {color: "black", width: "95%"}} id={"accordion-iias-active"}>
                        <Accordion.Item eventKey="0" className='label-style'>
                            <Accordion.Header className='document-item label-style'>Assessment</Accordion.Header>
                            <Accordion.Body className='border-hidden label-style' >
                                <div style={{paddingLeft: 12, paddingTop: 15, paddingBottom: 20}}>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>Details of the assessment(s) were communicated to me before the start of the course</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.methods_details_communication["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_details_communication["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_details_communication["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_details_communication["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_details_communication["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The actual assessment(s) were like what was communicated beforehand</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.methods_communication_correspondence["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_communication_correspondence["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_communication_correspondence["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_communication_correspondence["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_communication_correspondence["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The assessment(s) represented the subjects discussed in the course</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.methods_subject_consistency["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_subject_consistency["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_subject_consistency["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_subject_consistency["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_subject_consistency["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The assessment(s) was/were applied fairly with attention to cultural differences of the students</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.methods_cultural_attention["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_cultural_attention["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_cultural_attention["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_cultural_attention["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_cultural_attention["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>I am satisfied with what I’ve learned during the course</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.methods_learning_satisfaction["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_learning_satisfaction["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_learning_satisfaction["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_learning_satisfaction["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.methods_learning_satisfaction["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion></Col></Row>
                    <Row style={{ marginLeft: 0, marginRight: 0}}><Col style={{marginBottom: 80}}>
                        <Accordion className='border-hidden label-style mx-auto' style={(size !== "xs" && size !== "sm" && size !== "md") ? {color: "black", width: "80%"} : {color: "black", width: "95%"}} id={"accordion-iias-active"}>
                        <Accordion.Item eventKey="0" className='label-style'>
                            <Accordion.Header className='document-item label-style'>Evaluation</Accordion.Header>
                            <Accordion.Body className='border-hidden label-style' >
                                <div style={{paddingLeft: 12, paddingTop: 15, paddingBottom: 20}}>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The course is sufficiently evaluated</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.evaluation_sufficiency["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.evaluation_sufficiency["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.evaluation_sufficiency["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.evaluation_sufficiency["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.evaluation_sufficiency["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>There was enough room to share my thoughts about the course with the teacher(s)</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.evaluation_sharing_opportunities["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.evaluation_sharing_opportunities["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.evaluation_sharing_opportunities["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.evaluation_sharing_opportunities["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.evaluation_sharing_opportunities["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true } }}
                                    />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>The timing of the evaluations was fitting</div>
                                    </Col>
                                    <Col lg={6} className='flex-center' style={{height: 70}}>
                                    <BarChart
                                        yAxis={[{ scaleType: 'band', data: ['Results'] }]}
                                        series={[{ data: [data?.Evaluations?.likert_scale_fields?.evaluation_timing["1"]], stack: 'A', label: 'Strongly disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.evaluation_timing["2"]], stack: 'A', label: 'Disagree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.evaluation_timing["3"]], stack: 'A', label: 'Neutral' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.evaluation_timing["4"]], stack: 'A', label: 'Agree' }, 
                                        { data: [data?.Evaluations?.likert_scale_fields?.evaluation_timing["5"]], stack: 'A', label: 'Strongly agree' }]}
                                        width={600}
                                        height={140}
                                        layout="horizontal"
                                        barLabel="value"
                                        leftAxis={null}
                                        bottomAxis={null}
                                        slotProps={{ legend: { hidden: true, padding: 0 } }}
                                    />
                                    </Col>
                                </Row>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion></Col></Row>
                    <Row style={{ marginLeft: 0, marginRight: 0}}><Col style={{marginBottom: 80}}>
                        <Accordion className='border-hidden label-style mx-auto' style={(size !== "xs" && size !== "sm" && size !== "md") ? {color: "black", width: "80%"} : {color: "black", width: "95%"}} id={"accordion-iias-active"}>
                        <Accordion.Item eventKey="0" className='label-style'>
                            <Accordion.Header className='document-item label-style'>Concluding</Accordion.Header>
                            <Accordion.Body className='border-hidden label-style' >
                                <div style={{paddingLeft: 12, paddingTop: 15, paddingBottom: 20}}>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center'>
                                    <div className='question-title'>What are your main motives to participate in this course?</div>
                                    <div className='flex-center'><PieChart
                                        series={[
                                            {arcLabel: (item) => item.value,
                                            arcLabelMinAngle: 35,
                                            arcLabelRadius: '60%',
                                            data: [
                                                { id: 0, value: data?.Evaluations?.enum_fields?.general_participation_motives["Academic opportunities"], label: 'Academic opportunities' },
                                                { id: 1, value: data?.Evaluations?.enum_fields?.general_participation_motives["Career advancement"], label: 'Career advancement' },
                                                { id: 2, value: data?.Evaluations?.enum_fields?.general_participation_motives["Experiencing different cultures"], label: 'Experiencing different cultures' },
                                                { id: 3, value: data?.Evaluations?.enum_fields?.general_participation_motives["Other"], label: 'Other' },
                                                { id: 4, value: data?.Evaluations?.enum_fields?.general_participation_motives["Personal motives"], label: 'Personal motives' },
                                                { id: 5, value: data?.Evaluations?.enum_fields?.general_participation_motives["Quality of education"], label: 'Quality of education' }
                                            ],
                                            },
                                        ]}
                                        sx={{
                                            [`& .${pieArcLabelClasses.root}`]: {
                                              fontWeight: 'bold',
                                            },
                                          }}
                                        width={400}
                                        height={450}
                                        margin={{ top: 50, bottom: 100, left: 100, right:100 }}
                                        slotProps={{
                                            legend: {
                                            //   labelStyle: {
                                            //     tableLayout: 'fixed',
                                            //   },
                                              direction: 'row',
                                              position: {
                                                horizontal: 'middle',
                                                vertical: 'bottom',
                                              },padding: 0,
                                            },
                                          }}
                                    /></div>
                                    </Col>
                                    <Col lg={6} className='flex-center'>
                                    <div className='question-title'>What are you most satisfied with regarding the course?</div>
                                    <div className='flex-center'><PieChart
                                        series={[
                                            {arcLabel: (item) => item.value,
                                            arcLabelMinAngle: 35,
                                            arcLabelRadius: '60%',
                                            data: [
                                                { id: 0, value: data?.Evaluations?.enum_fields?.general_satisfaction_aspects["Interaction with students"], label: 'Interaction with students' },
                                                { id: 1, value: data?.Evaluations?.enum_fields?.general_satisfaction_aspects["Other"], label: 'Other' },
                                                { id: 2, value: data?.Evaluations?.enum_fields?.general_satisfaction_aspects["The assessment(s)"], label: 'The assessment(s)' },
                                                { id: 3, value: data?.Evaluations?.enum_fields?.general_satisfaction_aspects["The content"], label: 'The content' },
                                                { id: 4, value: data?.Evaluations?.enum_fields?.general_satisfaction_aspects["The learning activities"], label: 'The learning activities' },
                                                { id: 5, value: data?.Evaluations?.enum_fields?.general_satisfaction_aspects["The learning materials"], label: 'The learning materials' },
                                                { id: 6, value: data?.Evaluations?.enum_fields?.general_satisfaction_aspects["The lectures"], label: 'The lectures' },
                                                { id: 7, value: data?.Evaluations?.enum_fields?.general_satisfaction_aspects["The set-up/design"], label: 'The set-up/design' },
                                                { id: 8, value: data?.Evaluations?.enum_fields?.general_satisfaction_aspects["The support of teachers"], label: 'The support of teachers' }
                                            ],
                                            },
                                        ]}
                                        sx={{
                                            [`& .${pieArcLabelClasses.root}`]: {
                                              fontWeight: 'bold',
                                            },
                                          }}
                                        width={400}
                                        height={450}
                                        margin={{ top: 50, bottom: 100, left: 100, right:100 }}
                                        slotProps={{
                                            legend: {
                                            //   labelStyle: {
                                            //     tableLayout: 'fixed',
                                            //   },
                                              direction: 'row',
                                              position: {
                                                horizontal: 'middle',
                                                vertical: 'bottom',
                                              },padding: 0,
                                            },
                                          }}
                                    /></div>
                                    </Col>
                                </Row>
                                <Row style={{marginTop: 25}}>
                                    <Col lg={6} className='flex-center'>
                                    <div className='question-title'>Would you advise other exchange students to join this course?</div>
                                    <div className='flex-center'><PieChart
                                        series={[
                                            {arcLabel: (item) => item.value,
                                            arcLabelMinAngle: 35,
                                            arcLabelRadius: '60%',
                                            data: [
                                                { id: 0, value: data?.Evaluations?.enum_fields?.general_would_recommend["No"], label: 'No' },
                                                { id: 1, value: data?.Evaluations?.enum_fields?.general_would_recommend["Other"], label: 'Other' },
                                                { id: 2, value: data?.Evaluations?.enum_fields?.general_would_recommend["Yes"], label: 'Yes' },
                                                { id: 3, value: data?.Evaluations?.enum_fields?.general_would_recommend["Not sure"], label: 'Not Sure' },
                                            ],
                                        },
                                        ]}
                                        sx={{
                                            [`& .${pieArcLabelClasses.root}`]: {
                                              fontWeight: 'bold',
                                            },
                                          }}
                                        width={400}
                                        height={400}
                                        margin={{ top: 50, bottom: 100, left: 100, right:100 }}
                                        slotProps={{
                                            legend: {
                                            //   labelStyle: {
                                            //     tableLayout: 'fixed',
                                            //   },
                                              direction: 'row',
                                              position: {
                                                horizontal: 'middle',
                                                vertical: 'bottom',
                                              },padding: 0,
                                            },
                                          }}
                                    /></div>
                                    </Col>
                                    <Col lg={6} className='flex-center'>
                                    </Col>
                                </Row>
                                {/* <hr style={{marginTop: 20, marginBottom: 20}}/>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>Please explain what you liked or disliked from the course</div>
                                    </Col>
                                    <Col lg={6} className='flex-center'>
                                        <TableContainer sx={{ maxHeight: 200 }}>
                                        <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                            
                                                <TableCell>
                                                {}
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data?.Evaluations?.text_fields?.general_likes_dislikes?.map((row) => {
                                                return (
                                                <TableRow hover>
                                                    
                                                        <TableCell >
                                                        {row}
                                                        </TableCell>
                                                </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                        </Table>
                                    </TableContainer>
                                    </Col>
                                </Row>
                                <hr style={{marginTop: 20, marginBottom: 20}}/>
                                <Row style={{marginTop: 30}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>Please explain why you would or wouldn’t advise other exchange students to join this course</div>
                                    </Col>
                                    <Col lg={6} className='flex-center'>
                                        <TableContainer sx={{ maxHeight: 200 }}>
                                        <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                            
                                                <TableCell>
                                                {}
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data?.Evaluations?.text_fields?.general_recommendation_explanation?.map((row) => {
                                                return (
                                                <TableRow hover>
                                                    
                                                        <TableCell >
                                                        {row}
                                                        </TableCell>
                                                </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                        </Table>
                                    </TableContainer>
                                    </Col>
                                </Row>
                                <hr style={{marginTop: 20, marginBottom: 20}}/>
                                <Row style={{marginTop: 12}}>
                                    <Col lg={6} className='flex-center' style={{justifyContent: "flex-start"}}>
                                    <div className='question-title'>Are there any other personal thoughts and experiences as an exchange student you would like to share with us?</div>
                                    </Col>
                                    <Col lg={6} className='flex-center'>
                                        <TableContainer sx={{ maxHeight: 200 }}>
                                        <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                            
                                                <TableCell>
                                                {}
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data?.Evaluations?.text_fields?.general_thoughts?.map((row) => {
                                                return (
                                                <TableRow hover>
                                                    
                                                        <TableCell >
                                                        {row}
                                                        </TableCell>
                                                </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                        </Table>
                                    </TableContainer>
                                    </Col>
                                </Row> */}
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion></Col></Row>
    
    </>
  );
}